/* ===== AROMAZUR : témoignages de clients professionnels =====
   Retours recueillis directement auprès de clients professionnels (mail / téléphone),
   retranscrits fidèlement, sans modification du texte.
   Présentés comme témoignages (et non comme avis notés « achat vérifié »). */

window.AZ_PRO_TESTIMONIALS = [
 {
  "a": "Lucie B.",
  "t": "Institut de beauté",
  "te": "Beauty institute",
  "d": "Avril 2025",
  "de": "April 2025",
  "x": "Très impressionnée par la qualité de diffusion ! L'odeur reste dans l'air pendant des heures sans être entêtante. En plus, le design est sobre et élégant, parfait pour notre espace. Installation rapide et aucune goutte d'eau, que du parfum pur.",
  "xe": "Very impressed by the quality of the diffusion! The scent lingers in the air for hours without being overpowering. The design is understated and elegant, perfect for our space. Quick installation and not a drop of water — pure fragrance only.",
  "n": 5,
  "h": "az-diffuseur-d-huiles-parfumees-professionnel"
 },
 {
  "a": "Manon G.",
  "t": "Salon de coiffure",
  "te": "Hair salon",
  "d": "Avril 2025",
  "de": "April 2025",
  "x": "J'utilise ce diffuseur dans mon salon de coiffure depuis deux semaines, et mes clientes me demandent souvent quelle est cette bonne odeur. Il est silencieux, puissant, et très élégant.",
  "xe": "I have been using this diffuser in my hair salon for two weeks, and my clients often ask me what that lovely scent is. It is silent, powerful and very elegant.",
  "n": 4,
  "h": "az-diffuseur-d-huiles-parfumees-professionnel"
 },
 {
  "a": "Inès V.",
  "t": "Hôtel",
  "te": "Hotel",
  "d": "Avril 2025",
  "de": "April 2025",
  "x": "Nous cherchions une solution pour parfumer le hall sans système complexe, ce diffuseur est parfait. L'autonomie est bonne, et il ne chauffe pas.",
  "xe": "We were looking for a way to scent our lobby without a complex system — this diffuser is perfect. Good autonomy, and it does not heat up.",
  "n": 3,
  "h": "az-diffuseur-d-huiles-parfumees-professionnel"
 },
 {
  "a": "Maxime L.",
  "t": "Espace de coworking",
  "te": "Coworking space",
  "d": "Avril 2025",
  "de": "April 2025",
  "x": "Je gère un espace de coworking, et les retours sont super positifs depuis qu'on a installé ce diffuseur. Ça change l'ambiance sans être envahissant.",
  "xe": "I manage a coworking space, and the feedback has been very positive since we installed this diffuser. It changes the atmosphere without being intrusive.",
  "n": 4,
  "h": "az-diffuseur-d-huiles-parfumees-professionnel"
 },
 {
  "a": "Nicolas R.",
  "t": "Boutique",
  "te": "Retail store",
  "d": "Avril 2025",
  "de": "April 2025",
  "x": "L'odeur est bien répartie dans tout le magasin. On l'utilise avec l'huile Cabana, ça donne une ambiance vraiment agréable.",
  "xe": "The scent is evenly spread throughout the store. We use it with the Cabana oil — it creates a really pleasant atmosphere.",
  "n": 5,
  "h": "az-diffuseur-d-huiles-parfumees-professionnel"
 }
];

(function(){
  function lang(){ try{return localStorage.getItem('az_lang')||'fr';}catch(e){return 'fr';} }
  function css(){
    if(document.getElementById('azProStyle')) return;
    var s=document.createElement('style'); s.id='azProStyle';
    s.textContent=
     '.az-pro-wrap{padding:74px 20px;background:#111111}'+
     '.az-pro-inner{max-width:1180px;margin:0 auto}'+
     '.az-pro-head{text-align:center;margin-bottom:44px}'+
     '.az-pro-eyebrow{font-family:Georgia,serif;font-size:11px;letter-spacing:4px;color:#D4A63C;text-transform:uppercase}'+
     '.az-pro-title{font-family:Georgia,serif;font-size:31px;color:#fff8f0;margin:14px 0 12px;font-weight:normal}'+
     '.az-pro-sub{font-family:Georgia,serif;font-size:14px;color:#9a9284;max-width:660px;margin:0 auto;line-height:1.7}'+
     '.az-pro-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));gap:18px}'+
     '.az-pro-card{background:#171717;border:1px solid #2a2a2a;padding:28px 26px;display:flex;flex-direction:column;transition:border-color .3s}'+
     '.az-pro-card:hover{border-color:#D4A63C}'+
     '.az-pro-quote{font-family:Georgia,serif;font-size:30px;color:#D4A63C;line-height:1;margin-bottom:10px}'+
     '.az-pro-text{font-family:Georgia,serif;font-size:14.5px;line-height:1.8;color:#e6e0d6;flex:1;font-style:italic}'+
     '.az-pro-meta{margin-top:20px;padding-top:15px;border-top:1px solid #2a2a2a}'+
     '.az-pro-type{font-family:Georgia,serif;font-size:13px;color:#D4A63C;letter-spacing:1.5px}'+
     '.az-pro-auth{font-family:Georgia,serif;font-size:11.5px;color:#8a8272;margin-top:4px;letter-spacing:.5px}'+
     '.az-pro-note{text-align:center;margin-top:34px;font-family:Georgia,serif;font-size:11.5px;color:#6f6a60;line-height:1.7}';
    document.head.appendChild(s);
  }
  function build(){
    if(document.getElementById('azProSection')) return;
    var host=document.getElementById('b2b'); if(!host) return;
    var d=window.AZ_PRO_TESTIMONIALS||[]; if(!d.length) return;
    css();
    var en=(lang()==='en');
    var sec=document.createElement('section');
    sec.id='azProSection'; sec.className='az-pro-wrap';
    sec.innerHTML=
      '<div class="az-pro-inner">'+
        '<div class="az-pro-head">'+
          '<div class="az-pro-eyebrow">'+(en?'THEY CHOSE AROMAZUR':'ILS NOUS FONT CONFIANCE')+'</div>'+
          '<h2 class="az-pro-title">'+(en?'What professionals say':'La parole aux professionnels')+'</h2>'+
          '<p class="az-pro-sub">'+(en
             ? 'Hotels, beauty institutes, salons, boutiques and coworking spaces have already adopted our professional diffusion.'
             : 'Hôtels, instituts, salons, boutiques et espaces de coworking ont déjà adopté notre diffusion professionnelle.')+'</p>'+
        '</div>'+
        '<div class="az-pro-grid">'+
          d.map(function(r){
            return '<div class="az-pro-card">'+
              '<div class="az-pro-quote">&ldquo;</div>'+
              '<div class="az-pro-text">'+(en?r.xe:r.x)+'</div>'+
              '<div class="az-pro-meta">'+
                '<div class="az-pro-type">'+(en?r.te:r.t)+'</div>'+
                '<div class="az-pro-auth">'+r.a+' · '+(en?r.de:r.d)+'</div>'+
              '</div></div>';
          }).join('')+
        '</div>'+
        '<div class="az-pro-note">'+(en
          ? 'Feedback collected directly from professional customers and transcribed faithfully.'
          : 'Retours recueillis directement auprès de clients professionnels et retranscrits fidèlement.')+'</div>'+
      '</div>';
    /* Accueil restructure (08/09/2026) : la preuve sociale precede l'appel B2B. */
    host.parentNode.insertBefore(sec, host);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', build);
  else setTimeout(build,0);
})();
